import { create } from "zustand";

const COUNTRY_STORAGE_KEY = 'selectedCountry';

const countryStore = (set, get) => ({
    selectedCountry: null,
    detectedCountry: null,
    isCountryModalOpen: false,
    
    // Initialize country from sessionStorage
    initializeCountry: () => {
        const storedCountry = sessionStorage.getItem(COUNTRY_STORAGE_KEY);
        if (storedCountry) {
            try {
                const country = JSON.parse(storedCountry);
                set({ selectedCountry: country, isCountryModalOpen: false });
                return country;
            } catch (error) {
                console.error('Error parsing stored country:', error);
                sessionStorage.removeItem(COUNTRY_STORAGE_KEY);
            }
        }
        return null;
    },
    
    // Set detected country (from IP geolocation)
    setDetectedCountry: (country) => {
        set({ detectedCountry: country });
    },
    
    // Set selected country and store in sessionStorage
    setSelectedCountry: (country) => {
        if (country) {
            sessionStorage.setItem(COUNTRY_STORAGE_KEY, JSON.stringify(country));
            set({ selectedCountry: country, isCountryModalOpen: false });
        }
    },
    
    // Open country selection modal
    openCountryModal: () => {
        set({ isCountryModalOpen: true });
    },
    
    // Close country selection modal
    closeCountryModal: () => {
        set({ isCountryModalOpen: false });
    },
    
    // Get country code (for API calls)
    getCountryCode: () => {
        const { selectedCountry } = get();
        return selectedCountry?.code || null;
    },
    
    // Get country name
    getCountryName: () => {
        const { selectedCountry } = get();
        return selectedCountry?.name || null;
    },
});

const useCountryStore = create(countryStore);
export default useCountryStore;

